module.exports = __webpack_public_path__ + "img/mhfr-logo.678ee18a.svg";